import { render } from "./NBURates.vue?vue&type=template&id=07593bbe&scoped=true&ts=true"
import script from "./NBURates.vue?vue&type=script&lang=ts"
export * from "./NBURates.vue?vue&type=script&lang=ts"

import "./NBURates.vue?vue&type=style&index=0&id=07593bbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07593bbe"]])

export default __exports__